import { Injectable } from '@angular/core';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { map, shareReplay, take } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { LocalStorageUtil } from '~shared/utils/localstorage.util';
import { BLACK_DEALS_LOCAL_STORAGE_KEY, FeatureToggleEnum } from '~shared/constants';

@Injectable({
  providedIn: 'root'
})
export class BlackDealsFeatureFlagService {
  private readonly blackDealsFeatureFlagEnabled$: Observable<boolean>;
  private isBlackDealsEnabledFlag = false;

  constructor(
    private activeFeaturesService: ActiveFeaturesConfigcatService
  ) {
    this.blackDealsFeatureFlagEnabled$ = this.activeFeaturesService
      .isFeatureEnabledAndReady(FeatureToggleEnum.FF_BLACK_FRIDAY_COUNTDOWN, false)
      .pipe(
        take(1),
        map((isEnabled) => isEnabled || this.isBlackDealsServiceLocalStorageEnabled()),
        shareReplay(1)
      );
  }

  private isBlackDealsServiceLocalStorageEnabled(): boolean {
    return LocalStorageUtil.isFeatureEnabled(BLACK_DEALS_LOCAL_STORAGE_KEY);
  }

  public isEnabled(): Observable<boolean> {
    return this.blackDealsFeatureFlagEnabled$;
  }

  public initIsBlackDealsEnabledFlag() {
    this.blackDealsFeatureFlagEnabled$
    .subscribe((isBlackDealsEnabled: boolean) => {
      this.isBlackDealsEnabledFlag = isBlackDealsEnabled;
    });
  }

  /**
   * @description This function uses the service variable which is initialized at the start of the
   * application with the boolean of blackDealsEnabled Feature flag.
   * Don't use this function in the start of ngOnInit or constructor of any Parent/Main component,
   * in CSR you will get the correct value but in SSR cycle it will give you a undefined because
   * the serivce observable will also be running at the same time.
   * @returns boolean for blackDealsEnabled Feature flag
   */
  public isBlackDealsEnabled() : boolean {
    return this.isBlackDealsEnabledFlag;
  }
}
